import TradeDetails from "../components/TradeDetails";
import axios from "axios";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import config from './../config';

const Traded = () => {
  const companyId = useSelector((state) => state.user.companyId);
  const email1 = useSelector((state) => state.user.email);
  const navigate = useNavigate();
  const [baskets, setBaskets] = useState([])
  const [err, setErr] = useState("");
  const [messageType, setMessageType] = useState("");
  const [loading, setLoading] = useState(false);
  /* useEffect(() => {
    if (email1 === null || email1 === "") {
      navigate("/")
    }
  }) */
  useEffect(() => {
    getPendingActions(true)
  }, [])

  const getPendingActions = async (showLoader = false) => {

    if (showLoader) {
      setLoading(true);
    }

    try {

      const res = await axios.get(`${config.BL_API_URL}/transaction/v1/getTradedReport/${companyId}`);
      //console.log(res)

      if (res.data)
        setBaskets(res.data)
      else
        setErr("backend error")

    } catch (err) {
      //console.log("error 333 ", err)
      //if (err.response.status === 500)
      setErr("Server error...");
      //else
      //    setErr(err.response.data);
      if (err?.response?.data) setErr(err.response.data);
    } finally {
      if (showLoader) {
        setLoading(false);
      }
    }
  }

  const normalizeKey = (key) => String(key || "").replace(/[^a-zA-Z0-9]/g, "").toLowerCase();

  const getValueFromAliasesDeep = (obj, aliases) => {
    if (!obj || typeof obj !== "object") return "";

    const targetKeys = aliases.map((alias) => normalizeKey(alias));
    const queue = [obj];
    const seen = new Set();

    while (queue.length > 0) {
      const current = queue.shift();
      if (!current || typeof current !== "object") continue;
      if (seen.has(current)) continue;
      seen.add(current);

      for (const [key, value] of Object.entries(current)) {
        const normalizedCurrentKey = normalizeKey(key);
        if (
          targetKeys.includes(normalizedCurrentKey) &&
          value !== undefined &&
          value !== null &&
          String(value).trim() !== ""
        ) {
          return value;
        }
      }

      for (const value of Object.values(current)) {
        if (Array.isArray(value)) {
          for (const item of value) {
            if (item && typeof item === "object") {
              queue.push(item);
            }
          }
        } else if (value && typeof value === "object") {
          queue.push(value);
        }
      }
    }

    return "";
  };

  const getSummaryClientCount = (row) => {
    const clientCountAliases = [
      "uniqueClientCount",
      "clientCount",
      "totalClients",
      "totalClient",
      "totalClientCount"
    ];

    for (const alias of clientCountAliases) {
      const value = Number(getValueFromAliasesDeep(row, [alias]));
      if (Number.isFinite(value) && value >= 0) {
        return value;
      }
    }

    const clientCode = String(getValueFromAliasesDeep(row, ["clientCode", "clientcode", "client_code"]) || "").trim();
    if (clientCode !== "") {
      return 1;
    }

    return null;
  };

  const groupedBaskets = baskets.reduce((groups, item) => {
    const status = item.status ? item.status : 'open';
    const key = `${item.basketId}-${status}`;
    if (!groups[key]) {
      groups[key] = {
        rows: [],
        totalClientCount: 0,
        hasSummaryClientCount: false,
        totalStatusCount: 0
      };
    }
    groups[key].rows.push(item);

    const parsedErrorCount = Number(item.errorCount);
    groups[key].totalStatusCount += Number.isFinite(parsedErrorCount) && parsedErrorCount >= 0 ? parsedErrorCount : 1;

    const parsedClientCount = getSummaryClientCount(item);
    if (parsedClientCount !== null) {
      groups[key].totalClientCount += parsedClientCount;
      groups[key].hasSummaryClientCount = true;
    }

    return groups;
  }, {});
  const keys = Object.keys(groupedBaskets);

  const getUniqueClientCount = (rows = []) => {
    const clients = new Set(
      rows
        .map((row) => String(row?.clientCode || "").trim())
        .filter((clientCode) => clientCode !== "")
    );
    return clients.size;
  };

  return (
    <div className=" my-14 md:px-14 max-w-screen-2xl mx-auto py-5">
      {loading && baskets.length === 0 && (
        <div className="py-8 px-3 flex justify-center items-center text-gray-600">
          <div className="flex items-center gap-3">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
            <span>Loading traded report...</span>
          </div>
        </div>
      )}
      
      {/*       <div className="py-1 px-1 flex justify-center items-center">
        <select>
          <option value="0">None</option>
          <option value="1">Orders Rejected</option>
          <option value="2">Order Generated But no yet sent for execution</option>
        </select>
      </div> */}
      {/* <div className="mx-24">
        {baskets.map((basket) => (
          <PendingActionDetails basketId={basket.basketId} keyName={basket.basketName} basket={basket} status={basket.status} />
        ))}
      </div>       */}
      {/* {err} */}
      {keys.length > 0 ? (
        keys.map((key) => {
          const group = groupedBaskets[key];
          const uniqueClientCount = group.hasSummaryClientCount ? group.totalClientCount : group.totalStatusCount;

          return (
          <div key={key}>

            {group.rows.map((basket) => (
              <TradeDetails basketId={basket.basketId} keyName={basket.basketName} basket={basket} status={key.substring(key.indexOf('-') + 1)} uniqueClientCount={uniqueClientCount} />
            ))}
          </div>
        )})
      ) : (
        !loading && (
          <div className="py-1 px-1 flex justify-center items-center">
            <span className="mb-6 ml-4 text-lg ">No records</span>
          </div>
        )
      )}

    </div>
  )
}

export default Traded